import { csmHubSetupResource } from '@jira/router-resources__customer-service-common/src/csmHubSetupResource.tsx';
import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsDetailsRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsDetailsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import {
	composeLayouts,
	layoutWithCondition,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { csmWidgetLayout } from '@jira/customer-service__csm-support-widget-layout/src/csmWidgetLayout.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { helpCenterSettingDetailsAppPageEntryPoint } from './ui/details/index.tsx';

export const helpCenterSettingsDetailsRouteEntry: Route = createEntry(
	helpCenterSettingsDetailsRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.details',
		layout: layoutWithCondition(
			() => fg('csm-support-widget-in-csm'),
			composeLayouts(serviceProjectLayout, csmWidgetLayout),
			serviceProjectLayout,
		),
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint() {
			return helpCenterSettingDetailsAppPageEntryPoint;
		},
		resources: [
			...getServiceDeskSettingsResources(),
			csmHubSetupResource,
			customerExperiencesNavigationResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
